"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @export
 * @enum {string}
 */
var MetaformFieldType;
(function (MetaformFieldType) {
    MetaformFieldType["Text"] = "text";
    MetaformFieldType["Url"] = "url";
    MetaformFieldType["Hidden"] = "hidden";
    MetaformFieldType["Email"] = "email";
    MetaformFieldType["Number"] = "number";
    MetaformFieldType["Slider"] = "slider";
    MetaformFieldType["Memo"] = "memo";
    MetaformFieldType["Boolean"] = "boolean";
    MetaformFieldType["Radio"] = "radio";
    MetaformFieldType["Checklist"] = "checklist";
    MetaformFieldType["Date"] = "date";
    MetaformFieldType["Time"] = "time";
    MetaformFieldType["DateTime"] = "date-time";
    MetaformFieldType["Files"] = "files";
    MetaformFieldType["Table"] = "table";
    MetaformFieldType["Logo"] = "logo";
    MetaformFieldType["SmallText"] = "small-text";
    MetaformFieldType["Html"] = "html";
    MetaformFieldType["Submit"] = "submit";
    MetaformFieldType["Select"] = "select";
    MetaformFieldType["Autocomplete"] = "autocomplete";
    MetaformFieldType["AutocompleteMultiple"] = "autocomplete-multiple";
})(MetaformFieldType = exports.MetaformFieldType || (exports.MetaformFieldType = {}));
function MetaformFieldTypeFromJSON(json) {
    return MetaformFieldTypeFromJSONTyped(json, false);
}
exports.MetaformFieldTypeFromJSON = MetaformFieldTypeFromJSON;
function MetaformFieldTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.MetaformFieldTypeFromJSONTyped = MetaformFieldTypeFromJSONTyped;
function MetaformFieldTypeToJSON(value) {
    return value;
}
exports.MetaformFieldTypeToJSON = MetaformFieldTypeToJSON;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWV0YWZvcm1GaWVsZFR5cGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZ2VuZXJhdGVkL2NsaWVudC9tb2RlbHMvTWV0YWZvcm1GaWVsZFR5cGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLG9CQUFvQjtBQUNwQixvQkFBb0I7QUFDcEI7Ozs7Ozs7Ozs7R0FVRzs7QUFFSDs7OztHQUlHO0FBQ0gsSUFBWSxpQkF1Qlg7QUF2QkQsV0FBWSxpQkFBaUI7SUFDekIsa0NBQWEsQ0FBQTtJQUNiLGdDQUFXLENBQUE7SUFDWCxzQ0FBaUIsQ0FBQTtJQUNqQixvQ0FBZSxDQUFBO0lBQ2Ysc0NBQWlCLENBQUE7SUFDakIsc0NBQWlCLENBQUE7SUFDakIsa0NBQWEsQ0FBQTtJQUNiLHdDQUFtQixDQUFBO0lBQ25CLG9DQUFlLENBQUE7SUFDZiw0Q0FBdUIsQ0FBQTtJQUN2QixrQ0FBYSxDQUFBO0lBQ2Isa0NBQWEsQ0FBQTtJQUNiLDJDQUFzQixDQUFBO0lBQ3RCLG9DQUFlLENBQUE7SUFDZixvQ0FBZSxDQUFBO0lBQ2Ysa0NBQWEsQ0FBQTtJQUNiLDZDQUF3QixDQUFBO0lBQ3hCLGtDQUFhLENBQUE7SUFDYixzQ0FBaUIsQ0FBQTtJQUNqQixzQ0FBaUIsQ0FBQTtJQUNqQixrREFBNkIsQ0FBQTtJQUM3QixtRUFBOEMsQ0FBQTtBQUNsRCxDQUFDLEVBdkJXLGlCQUFpQixHQUFqQix5QkFBaUIsS0FBakIseUJBQWlCLFFBdUI1QjtBQUVELFNBQWdCLHlCQUF5QixDQUFDLElBQVM7SUFDL0MsT0FBTyw4QkFBOEIsQ0FBQyxJQUFJLEVBQUUsS0FBSyxDQUFDLENBQUM7QUFDdkQsQ0FBQztBQUZELDhEQUVDO0FBRUQsU0FBZ0IsOEJBQThCLENBQUMsSUFBUyxFQUFFLG1CQUE0QjtJQUNsRixPQUFPLElBQXlCLENBQUM7QUFDckMsQ0FBQztBQUZELHdFQUVDO0FBRUQsU0FBZ0IsdUJBQXVCLENBQUMsS0FBZ0M7SUFDcEUsT0FBTyxLQUFZLENBQUM7QUFDeEIsQ0FBQztBQUZELDBEQUVDIn0=